import { CSSObject } from '@chakra-ui/react';

export const TextItem: CSSObject = {
  textTransform: 'capitalize',
  fontFamily: 'body',
  color: 'white',
  fontSize: 'sm',
  fontWeight: 'bold',
  lineHeight: 'normal',
  pb: '1',
};
